











import {Vue, Component, Prop, Watch} from "vue-property-decorator";

@Component
export default class Likes extends Vue {
    @Prop({
        required: true,
        default: 0
    }) amount: number;
    @Prop({
        required: true,
        default: false
    }) isLiked: boolean;
    @Prop({
        required: false,
        default: 20
    }) width: number;
    @Prop({
        required: false,
        default: 18
    }) height: number;

    localAmount = 0;
    localIsLiked = false;

    @Watch('amount')
    public onAmountChange() {
        this.localAmount = this.amount;
        this.localIsLiked = this.isLiked;
    }

    mounted() {
        this.localAmount = this.amount;
        this.localIsLiked = this.isLiked;
    }

    emitValue() {
        this.$emit('changed', this.localIsLiked ? 1 : null);
    }

    toggle() {
        if (this.localIsLiked) {
            this.localIsLiked = false;
            this.localAmount = this.localAmount ? this.localAmount - 1 : 0;
        }
        else {
            this.localIsLiked = true;
            this.localAmount = this.localAmount ? this.localAmount + 1 : 1;
        }
        this.emitValue();
    }
}
